// Import React for creating the Button component
import React from "react";
// Import the CSS file for button styling
import "../../css/Button.css";

// Reusable Button component
// Props:
// - text: The button label
// - variant: Button style variant (e.g., 'primary', 'secondary')
// - onClick: Click event handler
// - className: Additional CSS classes
// - type: Button type (e.g., 'button', 'submit')
// - ...props: Any other props passed to the button
const Button = ({
  text,
  variant = "primary",
  onClick,
  className = "",
  type = "button",
  ...props
}) => {
  return (
    <button
      type={type}
      className={`pf-button pf-button-${variant} ${className}`}
      onClick={onClick}
      {...props}
    >
      {/* Render the button text */}
      {text}
    </button>
  );
};

// Export the Button component as default
export default Button;
